<div class="providers-table-container">
  @if (loading) {
    <div class="flex h-64 items-center justify-center">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }

  @if (!loading) {
    <div
      class="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-900"
    >
      <div
        class="flex items-center justify-between border-b border-gray-200 bg-gray-50 px-5 py-3 dark:border-gray-700 dark:bg-gray-800/70"
      >
        <p class="text-xs text-gray-500 dark:text-gray-400">
          Mostrando
          <span class="font-semibold text-gray-900 dark:text-gray-100">{{ providers.length }}</span>
          {{ providers.length === 1 ? 'proveedor' : 'proveedores' }}
        </p>
      </div>

      <p-table
        (onLazyLoad)="onPageChange($event)"
        [currentPageReportTemplate]="'Mostrando {first} - {last} de {totalRecords} proveedores'"
        [first]="first"
        [lazy]="true"
        [loading]="loading"
        [paginatorDropdownAppendTo]="'body'"
        [paginator]="true"
        [rowsPerPageOptions]="[10, 20, 50, 100]"
        [rows]="rows"
        [showCurrentPageReport]="true"
        [tableStyle]="{ 'min-width': '95rem' }"
        [totalRecords]="totalRecords"
        [value]="providers"
        styleClass="providers-table"
      >
        <ng-template pTemplate="header">
          <tr class="bg-gray-50 hover:bg-gray-50 dark:bg-gray-800/70 dark:hover:bg-gray-800/70">
            <th
              class="w-14 min-w-[72px] pl-5 text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400"
              scope="col"
            >
              ID
            </th>
            <th
              class="min-w-[220px] text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400"
              scope="col"
            >
              {{ 'providerModule.name' | translate }}
            </th>
            <th
              class="min-w-[220px] text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400"
              scope="col"
            >
              {{ 'providerModule.businessName' | translate }}
            </th>
            <th
              class="min-w-[190px] text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400"
              scope="col"
            >
              RUC
            </th>
            <th
              class="min-w-[210px] text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400"
              scope="col"
            >
              {{ 'providerModule.contact' | translate }}
            </th>
            <th
              class="min-w-[180px] text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400"
              scope="col"
            >
              {{ 'providerModule.address' | translate }}
            </th>
            <th
              class="min-w-[150px] text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400"
              scope="col"
            >
              {{ 'providerModule.rol' | translate }}
            </th>
            <th
              class="min-w-[140px] text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400"
              scope="col"
            >
              {{ 'providerModule.statusCoes' | translate }}
            </th>
            <th
              class="min-w-[140px] text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400"
              scope="col"
            >
              {{ 'usersModule.status' | translate }}
            </th>
            <th
              class="min-w-[130px] pr-5 text-right text-xs font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400"
              scope="col"
            >
              {{ 'providerModule.actions.title' | translate }}
            </th>
          </tr>
        </ng-template>

        <ng-template let-provider let-rowIndex="rowIndex" pTemplate="body">
          <tr
            [ngClass]="
              rowIndex % 2 === 0 ? 'bg-white dark:bg-gray-900' : 'bg-gray-50/60 dark:bg-gray-800/30'
            "
            class="transition-colors hover:bg-primary-50/40 dark:hover:bg-primary-900/10"
          >
            <td class="pl-5 py-4">
              <span
                class="rounded-md bg-gray-100 px-2 py-0.5 font-mono text-xs font-semibold text-gray-500 dark:bg-gray-800 dark:text-gray-300"
              >
                #{{ provider?.id || 'N/A' }}
              </span>
            </td>

            <td class="py-4">
              <div class="flex items-center gap-2">
                <div
                  class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 dark:bg-primary-900/20"
                >
                  <i class="pi pi-truck text-[13px] text-primary-600 dark:text-primary-300"></i>
                </div>
                <span
                  class="whitespace-nowrap text-sm font-medium text-gray-900 dark:text-gray-100"
                >
                  {{ provider?.provider_name || 'Sin nombre proveedor' }}
                </span>
              </div>
            </td>

            <td class="py-4">
              <div class="flex items-center gap-1.5">
                <i class="pi pi-building text-xs text-gray-400"></i>
                <span class="text-sm text-gray-700 dark:text-gray-300">
                  {{ provider?.business_name || 'Sin razon social' }}
                </span>
              </div>
            </td>

            <td class="py-4">
              <span
                class="inline-flex min-w-[180px] justify-center whitespace-nowrap rounded-md border border-gray-200 bg-gray-100 px-2.5 py-1 font-mono text-xs font-semibold text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200"
              >
                {{ provider?.ruc || provider?.RUC || 'Sin RUC' }}
              </span>
            </td>

            <td class="py-4">
              <div class="flex flex-col gap-1">
                <a
                  [href]="'mailto:' + (provider?.email || '')"
                  [pTooltip]="provider?.email || 'Sin correo'"
                  class="flex items-center gap-1.5 text-xs text-gray-500 transition-colors hover:text-primary-600 dark:text-gray-400 dark:hover:text-primary-300"
                  tooltipPosition="top"
                >
                  <i class="pi pi-envelope text-[11px]"></i>
                  <span class="max-w-[170px] truncate">{{ provider?.email || 'Sin correo' }}</span>
                </a>
                <div class="flex items-center gap-1.5 text-xs text-gray-500 dark:text-gray-400">
                  <i class="pi pi-phone text-[11px]"></i>
                  <span>{{ provider?.phone || 'Sin teléfono' }}</span>
                </div>
              </div>
            </td>

            <td class="py-4">
              <span
                [pTooltip]="provider?.address || 'Sin dirección'"
                class="block max-w-[150px] truncate text-sm text-gray-600 dark:text-gray-300"
                tooltipPosition="top"
              >
                {{ provider?.address || 'Sin dirección' }}
              </span>
            </td>

            <td class="py-4">
              <span
                [ngClass]="getRoleClass(provider?.user_data?.role)"
                class="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium"
              >
                <span class="h-1.5 w-1.5 shrink-0 rounded-full bg-current opacity-70"></span>
                {{ provider?.user_data?.role || 'Sin rol' }}
              </span>
            </td>

            <td class="py-4">
              <span
                [ngClass]="getCoesStatusClass(provider?.coes)"
                class="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium"
              >
                <span class="h-1.5 w-1.5 shrink-0 rounded-full bg-current opacity-70"></span>
                {{ provider?.coes || 'No COES' }}
              </span>
            </td>

            <td class="py-4">
              <span
                [ngClass]="getProviderStatusClass(provider?.is_active)"
                class="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold"
              >
                <span
                  [ngClass]="provider?.is_active ? 'bg-emerald-500' : 'bg-red-500'"
                  class="h-1.5 w-1.5 shrink-0 rounded-full"
                ></span>
                {{ provider?.is_active ? 'Activo' : 'Inactivo' }}
              </span>
            </td>

            <td class="py-4 pr-5">
              <div class="flex items-center justify-end gap-1">
                <p-button
                  (onClick)="onEdit(provider)"
                  [text]="true"
                  icon="pi pi-eye"
                  pTooltip="Ver proveedor"
                  severity="secondary"
                  styleClass="size-8"
                  tooltipPosition="top"
                  type="button"
                  variant="text"
                ></p-button>

                @if (provider.coes !== 'COES') {
                  <p-button
                    (onClick)="onToggleStatus(provider)"
                    [disabled]="!canToggleStatus(provider)"
                    [icon]="provider.is_active ? 'pi pi-ban' : 'pi pi-check'"
                    [pTooltip]="provider.is_active ? 'Desactivar' : 'Activar'"
                    [severity]="provider.is_active ? 'warn' : 'success'"
                    [text]="true"
                    styleClass="size-8"
                    tooltipPosition="top"
                    type="button"
                    variant="text"
                  ></p-button>
                }

                <p-button
                  (onClick)="delete.emit(provider)"
                  [text]="true"
                  icon="pi pi-trash"
                  pTooltip="Eliminar"
                  severity="danger"
                  styleClass="size-8"
                  tooltipPosition="top"
                  type="button"
                  variant="text"
                ></p-button>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="py-16 text-center text-sm text-gray-500 dark:text-gray-400" colspan="10">
              No se encontraron proveedores con los filtros actuales.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
</div>
